import { useCallback } from 'react';

import { showTooltip } from '@/helpers/tooltip';
import { useGetCommonStore } from '@/store';
import { TooltipTypes } from '@/store/tooltipStore';
import {
  type IssuableItem,
  isNewlyIssuedBonus,
  isNewlyWagerFreeCash,
  isWagerFreeCash,
} from '../lib/isUnseenBonus';
import { consumeWagerFreeSuppression } from '../lib/wagerFreeExchange';
import { BonusReceivedTooltip } from '../ui/BonusReceivedTooltip';
import { useActiveBonusesTabStore } from './activeBonusesTabStore';

type TIssuableCollection = 'bonuses' | 'freespins';

export const useNotifyBonusReceived = (): ((
  incoming: IssuableItem,
  collection: TIssuableCollection
) => void) => {
  const useCommonStore = useGetCommonStore();

  return useCallback(
    (incoming: IssuableItem, collection: TIssuableCollection) => {
      const previous = useCommonStore
        .getState()
        [collection].find((item) => item.id === incoming.id);

      const isWagerFree = isWagerFreeCash(incoming);

      const isNew = isWagerFree
        ? isNewlyWagerFreeCash(incoming, previous)
        : isNewlyIssuedBonus(incoming, previous);

      if (!isNew) return;

      if (isWagerFree && consumeWagerFreeSuppression()) return;

      if (!isWagerFree && useActiveBonusesTabStore.getState().isOpen) return;

      showTooltip({
        type: TooltipTypes.SUCCESS,
        body: <BonusReceivedTooltip incoming={incoming} />,
        pauseOnHover: true,
      });
    },
    [useCommonStore]
  );
};
